import React from "react";
import PropTypes from "prop-types";
import fields from "../../json/DestroyedFields.json";
import FormInput from "Common/Custom/FormInput";
import FormSelect from "Common/Custom/FormSelect";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";

const EditDestroyedForm = ({
  values = {},
  errors = {},
  handleChange = () => { },
  handleSubmit = () => { },
  loading = false,
  ProductOptions = [],
  title = "Update",
}) => {
  const { formdata } = fields;

  const renderField = (field) => {
    if (field.type === "select") {
      const options = ProductOptions.map((opt) => ({
        value: opt.id,
        label: opt.product_name,
      }));
      return (
        <FormSelect
          key={field.name}
          field={field}
          value={values[field.name] ?? ""}
          handleChange={handleChange}
          options={options}
          error={errors[field.name]}
        />
      );
    }

    if (field.type === "switch") {
      return (
        <Switch
          key={field.name}
          field={field}
          values={values[field.name]}
          handleChange={handleChange}
          ValueOne="1"
          ValueTwo="0"
          LabelOne="Active"
          LabelTwo="Inactive"
        />
      );
    }

    return (
      <FormInput
        key={field.name}
        field={field}
        value={values[field.name] ?? ""}
        handleChange={handleChange}
        error={errors[field.name]}
      />
    );
  };

  return (
    <PageBody
      headerchildren={<HeadingOne>{title}</HeadingOne>}
      onSubmit={handleSubmit}
    >
      {formdata.map(renderField)}

      <FormSubmitButton
        label={title}
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

EditDestroyedForm.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  loading: PropTypes.bool,
  ProductOptions: PropTypes.array,
  title: PropTypes.string,
};

export default EditDestroyedForm;
